<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}:
            | {{ modeName }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
            | {{ settings.difficult + ' x ' + settings.difficult }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_order') }}:
            | {{ $i18n.tc('trainer.trainer_gameFormSettingValue_' + settings.mode, 1) }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.numOfExamples }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_invertedTable') }}:
            | {{ isOptionOn(settings.invertedTable) }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_redAndBlack') }}:
            | {{ isOptionOn(settings.redAndBlack) }}
        br
        slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            withIcon: Boolean,
        },
        methods: {
            isOptionOn (option) {
                return option
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated')
            }
        },
        computed: {
            modeName () {
                return this.settings.amountOfTables === 1
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_oneTable')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_twoTables')
            }
        }
    }
</script>
